import styled from 'styled-components';

export const ProductTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 400;
  color: #000;
  line-height: 1.3;
  text-align: left;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;
